<template lang="pug">
div
  v-row
    v-col(cols="8")
      v-form(ref="form")
        v-card.pa-6.mt-4.round-xl(outlined)
          div.text-md.font-semibold.neutral700--text Point value
          .text-sm.neutral700--text(style="margin-top: 2px;") Set on how many points earned for every RM spent
          v-row.mt-2
            v-col(cols="4")
              div.text-sm.font-medium.neutral700--text RM spent
              v-text-field.text-sm.mt-2.round-xl(value="1.00" background-color="neutral300" :prefix="$currency.symbol" outlined dense height="48" disabled hide-details="auto")
            v-col(cols="4")
              div.text-sm.font-medium.neutral700--text Points earned
              v-text-field.text-sm.mt-2.round-xl(v-model="pointsEarned" background-color="neutral100" suffix="points" type="number" outlined dense height="48" hide-details="auto")

        v-card.pa-6.mt-4.round-xl(outlined)
          div.text-md.font-semibold.neutral700--text Redeem value
          .text-sm.neutral700--text(style="margin-top: 2px;") Set your reward redeem value
          v-card.round-xl.pa-6.mt-4(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
            v-row(no-gutters)
              v-col(cols="5")
                div.text-sm.font-medium.neutral700--text Cash rebate (RM)
              v-col.px-3(cols="5")
                div.text-sm.font-medium.neutral700--text Points to meet
            template(v-for="(reward, index) in rewards")
              v-row.mt-0(:key="`rw-${index}`")
                v-col(cols="5")
                  v-text-field.text-sm.round-xl(v-model="reward.rebate_amount" placeholder="10.00" background-color="neutral100" :prefix="$currency.symbol" type="number" outlined dense height="48" hide-details="auto")
                v-col(cols="5")
                  v-text-field.text-sm.round-xl(v-model="reward.tier_value" placeholder="100" background-color="neutral100" suffix="points" type="number" outlined dense height="48" hide-details="auto")
                v-col(cols="2")
                  v-btn.mt-2(icon color="transparent" small)
                    v-icon(color="neutral500" size="24" @click="removeReward(index)") $yzi-trash-03
            y-button.mt-4(label="Add new cash rebate" prepend-icon="$yzi-plus" size="sm" @click="rewards.push({})")

        v-card.pa-6.mt-4.round-xl(outlined)
          div.text-md.font-semibold.neutral700--text Upload logo
          v-row.mt-5(dense align="center")
            v-col.shrink
              div(style="width: 70px;")
                v-responsive(:aspect-ratio="1")
                  v-card.fill-height.round-xl(v-if="resizeImageFileUrl" flat)
                    v-img(:src="resizeImageFileUrl" height="70px" width="70px")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                  v-card.neutral300.fill-height.round-xl(v-else flat)
                    div.d-flex.align-center.justify-center.fill-height
                      v-icon(color="neutral500" size="45") $yzi-image-01
            v-col.grow
              div.pl-3
                div.text-sm.font-semibold.neutral700--text Company logo
                div.text-sm.neutral700--text.mt-2 Company logo has to be 1:1 (Square) dimension. File must be PNG or JPEG
            v-col.shrink
              y-button(v-if="loyaltySettings.logo" label="Remove" size="sm" :loading="isLoading" outlined block button-class="px-3" @click="removeImage(loyaltySettings.logo.id)")
              div.file-change-layout(v-else)
                div(style="width: 80px;")
                  y-button(label="Upload" size="sm" outlined block button-class="px-3")
                input.input-change-layout(type="file" @change="onFileChange" accept="image/*" style="width: 80px !important")

    v-col(cols="4")
      
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'
import InventoryServicesSelection from '@/components/clinic/marketing/InventoryServicesSelection.vue'
import SegmentSelection from '@/components/clinic/marketing/SegmentSelection.vue'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'

export default {
  components: { InventoryServicesSelection, SegmentSelection, DatePickerField },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      resizeImageFileUrl: null,
      resizeImageFile: null,
      pointsEarned: null,
      rewards: [{}],
      settings: {},
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      loyaltySettings: 'marketing/getLoyaltySettings'
    }),
    stampNumber () {
      let numbers = []
      for (let i = 1; i <=10; i++) {
        let obj = { text: i, value: i, disabled: false }
        if (this.rewards.map(m => m.tier_value).includes(i)) {
          obj.disabled = true
        }
        numbers.push(obj)
      }
      return numbers
    },
  },
  mounted () {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData () {
      let temp = this.loyaltySettings.rewards || []
      this.rewards = temp.map(m => { return { tier_value: m.tier_value, rebate_amount: Math.round(m.rebate_amount/this.$currency.multiplier) } })
      this.pointsEarned = this.loyaltySettings.points_earned
      this.resizeImageFileUrl = this.loyaltySettings?.logo?.file || null
    },
    removeReward (idx) {
      if (this.rewards.length === 1) {
        this.$set(this.rewards[idx], 'rebate_amount', null)
        this.$set(this.rewards[idx], 'tier_value', null)
      } else {
        this.rewards.splice(idx, 1)
      }
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    saveData () {
      if (!this.$refs.form.validate()) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      let payload = {
        points_earned: this.pointsEarned,
        rewards: this.rewards.map(m => {
          return {
            tier_value: m.tier_value,
            rebate_amount: Math.round(m.rebate_amount * this.$currency.multiplier)
          }
        })
      }
      this.$axios.patch(`/loyalty/${this.company.slug}`, payload)
        .then(resp => {
          if (this.resizeImageFile) {
            this.updateImage()
          } else {
            this.updateSuccess(resp)
          }
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
    },
    updateImage () {
      var formdata = new FormData()
      formdata.append('logo', this.resizeImageFile)
      this.$axios.patch(`/loyalty/${this.company.slug}`, formdata)
        .then(resp => {
          this.updateSuccess(resp)
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_upload_image')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
    },
    removeImage (id) {
      this.isLoading = true
      this.$axios.delete(`/images/${id}`)
        .then(() => {
          let data = this.loyaltySettings
          data.logo = null
          this.$store.commit('marketing/setLoyaltySettings', data)
          this.$nextTick(() => {
            this.setData()
          })
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_upload_image')
          if (err.response.data) {
            if (err.response.data.detail) {
              message = err.response.data.detail
            } else {
              let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
              if (data) { message = data }
            }
          }
          this.showMessage(['error', message])
          this.$emit('error')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateSuccess (resp) {
      this.$store.commit('marketing/setLoyaltySettings', resp.data)
      this.showMessage(['success', this.$t('success_message.successfully_updated')])
      this.$emit('updated')
      this.$nextTick(() => {
        this.setData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.file-change-layout {
  position: relative;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>